export enum InstallerComplianceStatusEnum {
	PENDING = 'PENDING',
	VALID = 'VALID',
	EXPIRED = 'EXPIRED',
	REJECTED = 'REJECTED'
}
